export const DESTINATIONS_FILENAME_TEMPLATES = [
  '{{orgId}}/{{sourcePhone}}/{{date timestamp "YYYY/MM/DD"}}.csv',
  '{{orgId}}/{{sourcePhone}}/{{date timestamp "YYYY/MM/DD"}}.json',
  '{{orgId}}/{{sourcePhone}}/{{date timestamp "YYYY/MM/DD"}}.parquet',
  '{{sourcePhone}}/{{date timestamp "YYYY/MM/DD"}}.csv',
  '{{sourcePhone}}/{{date timestamp "YYYY/MM/DD"}}.json',
  '{{sourcePhone}}/{{date timestamp "YYYY/MM/DD"}}.parquet',
];

/** The filename templates without their extension: a lake backfills every day file it finds under one, whatever the format. */
export const DESTINATIONS_FILES_PATH_TEMPLATES = [...new Set(DESTINATIONS_FILENAME_TEMPLATES.map((template) => template.replace(/\.\w+$/, "")))];
